import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

interface IContainerSize {
    width: number;
    height: number;
}

@Component({
    selector: 'template-preview',
    template: require('./template-preview.component.html'),
})
export class TemplatePreviewComponent implements AfterViewInit
{
    @ViewChild('screen', { static: true, read: ElementRef })
    screen: ElementRef;

    @ViewChild('screenContent', { static: true, read: ElementRef })
    screenContent: ElementRef;

    @ViewChild('templatePreviewFrame', { static: true, read: ElementRef })
    templatePreviewFrame: ElementRef;

    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        this.updateScreenScale();
    }

    devices = {
        "desktop-screen": { width: 1640, height: 887 },
        "tablet-screen": { width: 820, height: 1180 },
        "mobile-screen": { width: 390, height: 844 }
    };

	loading = false;

    currentDevice = "desktop-screen";

    currentWebsite = "company";

    templatePreviewFrameUrl: SafeResourceUrl;

    get previewId(): string {
        return this.data.template.Version.HeadId + "@" + this.currentWebsite + "@";
    }

    constructor(
        protected sanitizer: DomSanitizer,
		private bottomSheetRef: MatBottomSheetRef<TemplatePreviewComponent>,
		private spinner: NgxSpinnerService,
        @Inject(MAT_BOTTOM_SHEET_DATA) private data: any)
    {
        this.loadFrame();
    }

	private async loadFrame(): Promise<void> {
		this.loading = true;
		await this.spinner.show("publicTemplatePreviewSpinner");

        this.templatePreviewFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl("/templates/Preview/" + this.previewId);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.updateScreenScale();
        }, 10);
	}

	async loadComplete(): Promise<void> {
		this.loading = false;
		await this.spinner.hide("publicTemplatePreviewSpinner");
	}

	private async changeWebsite(website: string): Promise<void> {
        if (this.currentWebsite == website) return;
        this.currentWebsite = website;

		await this.loadFrame();
    }

    private changeDevice(device: string): void {
        if (this.currentDevice == device) return;
        this.currentDevice = device;
        setTimeout(() => { this.updateScreenScale(); }, 1);
    }

    private updateScreenScale(): void {
        const sRect = (this.screen.nativeElement as HTMLDivElement).getBoundingClientRect();
        const resizeTo = this.devices[this.currentDevice];
        const scale = this.getScaleData(sRect, resizeTo);
        (this.screenContent.nativeElement as HTMLDivElement).style.transform = "scale(" + scale + ")";
    }

    private getScaleData(a: IContainerSize, b: IContainerSize): any {
        return Math.min(a.width / b.width, a.height / b.height);
    }

    close(): void {
        this.bottomSheetRef.dismiss();
    }
}
